import React, { useState, useEffect } from 'react';
import * as d3 from 'd3';

import './LineChart.css';

const LineChart = props => {
  const { data } = props;
  const [svg, setSvg] = useState(null);

  useEffect(
    () => {
      if (svg) {
        drawChart(svg, props);
      }
    },
    [svg]
  );

  const drawChart = (svgRef, chartProps) => {
    const { parent, height } = chartProps;

    if (parent && parent.offsetWidth && svgRef) {
      const width = parent.offsetWidth;
      const xLabels = data.map(d => d.label);

      const margin = {
        top: 30,
        right: 7,
        bottom: 120,
        left: 50
      };

      const svgChart = d3
        .select(svgRef)
        .attr('width', width)
        .attr('height', height);

      svgChart.selectAll('*').remove();

      const x = d3.scaleLinear().range([0, width - margin.left - margin.right]);
      const y = d3
        .scaleLinear()
        .range([height - margin.top - margin.bottom, 0]);

      x.domain([0, data.length - 1]);
      y.domain([0, d3.max(data, d => parseFloat(d.value, 10))]);

      if (data && data.length) {
        const gridGroup = svgChart
          .append('g')
          .attr('class', 'grid-group')
          .attr('transform', `translate(${margin.left}, ${margin.top})`);

        const gridlines = d3
          .axisLeft()
          .tickFormat('')
          .tickSize(-width)
          .ticks(5)
          .scale(y);

        gridGroup
          .append('g')
          .attr('class', 'grid')
          .call(gridlines);
      }

      if (data && data.length) {
        const chartGroup = svgChart
          .append('g')
          .attr('class', 'chart-group')
          .attr('transform', `translate(${margin.left}, ${margin.top})`);

        const formatedData = data.map(d => ({
          label: d.label,
          value: parseInt(d.value, 10)
        }));

        const valueline = d3
          .line()
          .x((d, i) => x(i))
          .y(d => y(d.value));

        chartGroup
          .append('path')
          .data([formatedData])
          .attr('class', 'line')
          .attr('d', valueline);

        chartGroup
          .append('path')
          .data([formatedData])
          .attr('class', 'line')
          .attr('d', valueline);

        chartGroup
          .selectAll('line-circle')
          .data(formatedData)
          .enter()
          .append('circle')
          .attr('class', 'data-circle')
          .attr('r', 5)
          .attr('cx', (d, i) => x(i))
          .attr('cy', d => y(d.value));
      }

      const axisGroup = svgChart
        .append('g')
        .attr('class', 'axis-group')
        .attr('transform', `translate(${margin.left}, ${margin.top})`);

      axisGroup
        .append('g')
        .attr(
          'transform',
          `translate(0, ${height - margin.bottom - margin.top})`
        )
        .attr('class', 'axis')
        .call(
          d3.axisBottom(x).tickFormat(d => {
            if (Number.isInteger(d)) {
              return xLabels[d];
            }
            return null;
          })
        )
        .selectAll('text')
        .attr('y', 0)
        .attr('x', 9)
        .attr('dy', '.35em')
        .attr('transform', 'rotate(90)')
        .style('text-anchor', 'start');

      axisGroup
        .append('g')
        .attr('transform', `translate(0, 0)`)
        .attr('class', 'axis')
        .call(
          d3
            .axisLeft(y)
            .tickFormat(d => `€ ${d}`)
            .ticks(5)
        );
    }

    return null;
  };

  return (
    <div className="line-chart-container">
      {data && data.length ? (
        <svg
          ref={elem => {
            setSvg(elem);
          }}
        />
      ) : (
        <div className="no-chart-data">No data</div>
      )}
    </div>
  );
};

export default LineChart;
